import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import AlertTemplate from 'react-alert-template-basic'
import { BrowserRouter as Router } from 'react-router-dom';
import { transitions, positions, Provider as AlertProvider } from 'react-alert'
import { RiWhatsappLine } from 'react-icons/ri';

const options = {
    // you can also just use 'bottom center'
    position: positions.top_center,
    timeout: 5000,
    offset: '30px',
    // you can also just use 'scale'
    transition: transitions.SCALE
  }


ReactDOM.render(
    <Router>
        <AlertProvider template={AlertTemplate} {...options}>
            <App />
        </AlertProvider>
    </Router>,
    document.getElementById('root')
);